import { Modal } from 'antd';
import React, { CSSProperties, ReactNode } from 'react';
import CloseGlyph from '../../assets/icons/Glyph/CloseGlyph';
import './styles/simpleModal.style.scss';

export interface SimpleModalProps {
  readonly title: string | JSX.Element;
  readonly visible: boolean;
  readonly style?: CSSProperties;
  readonly onCancel: Function;
  readonly width?: number;
  readonly children: ReactNode;
  readonly className?: string;
  readonly destroyOnClose?: boolean;
  readonly closeColor?: string;
  readonly testID?: string;
}

const SimpleModal: React.FC<SimpleModalProps> = ({
  title,
  visible,
  children,
  style,
  onCancel,
  className,
  width = '950px',
  destroyOnClose = true,
  closeColor = '#FFF',
  ...props
}) => (
  <Modal
    width={width}
    visible={visible}
    title={title}
    footer={null}
    onCancel={() => onCancel()}
    closeIcon={<CloseGlyph color={closeColor} />}
    style={style}
    className={className}
    {...props}
    destroyOnClose={destroyOnClose}>
    {children}
  </Modal>
);

export default SimpleModal;
